import React, { useState } from 'react';
import { resetPassword } from '../api/consumerService'; // Update the path if needed
import { toast } from "react-toastify";

function ResetPasswordForm({ onSuccess, onBackToLogin }) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        try {
            setLoading(true);
            const payload = { newPassword, confirmPassword };
            await resetPassword(payload);
            toast.success("Password reset successfully");
            localStorage.clear();
            setNewPassword("");
            setConfirmPassword("");

            if (onSuccess) onSuccess(); // ✅ Fix: call passed prop
        } catch (error) {
            toast.error("Failed to reset password");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700">
                    New Password
                </label>
                <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    className="w-full px-3 py-2 border rounded-lg"
                />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">
                    Confirm Password
                </label>
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    className="w-full px-3 py-2 border rounded-lg"
                />
            </div>
            <div className="flex justify-between items-center">
                <button
                    type="button"
                    onClick={onBackToLogin}
                    className="text-sm text-blue-500 hover:underline"
                >
                    Back to Login
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg"
                >
                    {loading ? "Resetting..." : "Reset Password"}
                </button>
            </div>
        </form>
    );
}

export default ResetPasswordForm;
